import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { redirect } from 'widgets/I18nLink';
import {
  getDefaultBookingDate,
  getDefaultDropDate,
  getKey
} from 'utils';
import { toCityTimezone } from 'utils/dates';
import i18n from '../../i18n';

import AdvantagesSection from '../HomePage/AdvantagesSection';
import LeadSection from '../HomePage/LeadSection';
import HowItWorksSection from '../HomePage/HowItWorksSection';
import ReviewsSection from '../HomePage/ReviewsSection';
import NotFoundPage from '../NotFoundPage';

import CityBikesSection from './CityBikesSection';
import RelatedCitiesSection from './RelatedCitiesSection';
import StaticContentSection from './StaticContentSection';
import { ldJson } from './ldJson';

import 'components/HomePage/HomePage.css';

class StaticCityPage extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onSearchHandler = this.onSearch.bind(this);
    this.onSelectHandler = this.onSelect.bind(this);
  }

  componentWillMount() {
    if (this.props.error && typeof global !== 'undefined') {
      global.notFound = true;
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      this.props.clearCityBikes();
      this.props.clearStaticPage();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof global !== 'undefined') {
      global.notFound = !!this.props.error;
    }
  }

  getInitialFormState() {
    const {
      data,
      city,
      country,
      bikeTypes
    } = this.props;

    if (!data) {
      return;
    }

    const formState = {};

    if (city) {
      formState.country = country ? country.id : null;
      formState.pickUpCity = city.id;
      formState.dropOfCity = city.id;
      formState.returnAtSameCity = true;

      if (city.timezoneName) {
        formState.beginDateTime = toCityTimezone(new Date(), city)
          .add(5, 'day').startOf('day').set('hour', 10).toISOString();

        formState.endDateTime = toCityTimezone(new Date(), city)
          .add(8, 'day').startOf('day').set('hour', 10).toISOString();
      }
    }

    const bikeType = bikeTypes.find(({ id }) => id === data.searchBikeType);
    if (bikeType) {
      formState.bikeTypes = [bikeType.id];
    }

    return formState;
  }

  onSearch() {
    const {
      bikeTypes,
      country,
      pickUpCity,
      dropOfCity
    } = this.getInitialFormState();

    const query = {
      bikeTypes: bikeTypes.join(','),
      country,
      pickUpCity,
      dropOfCity,
      returnAtSameCity: true,
      begin: getDefaultBookingDate(),
      end: getDefaultDropDate()
    };

    redirect({
      pathname: '/search/',
      query
    });
  }

  onSelect(bike) {
    const { location, country, city } = this.props;

    const lang = location.pathname.split('/')[1];
    const pathname = `/detail/${bike.id}/`;
    const query = queryString.stringify({
      count: 1,
      country: country ? country.id : null,
      pickUpCity: country ? city.id : null,
      dropOfCity: country ? city.id : null,
      returnAtSameCity: true,
      extras: null,
      begin: getDefaultBookingDate(),
      end: getDefaultDropDate()
    });

    window.open(`/${lang}${pathname}${query ? '?' + query : ''}`, '_blank');
  }

  render() {
    const {
      data,
      city,
      cityBikes,
      countries,
      currency,
      bikeTypes,
      staticPages
    } = this.props;

    const json = ldJson({
      page: data,
      lang: i18n.language,
      city,
      bikes: cityBikes || [],
      bikeTypes: bikeTypes || []
    });

    const meta = [];
    const description = getKey(data, 'seoDescription');
    if (description) {
      meta.push({ name: 'description', content: description });
    }

    if (this.props.error) {
      return (
        <NotFoundPage {...this.props} />
      );
    }

    return (
      <div className="home-page">
        <Helmet
          meta={meta}
          title={getKey(data, 'seoTitle')}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
        ></script>

        <LeadSection
          bikeTypes={bikeTypes}
          countries={countries}
          h1={getKey(data, 'title')}
          initialState={this.getInitialFormState()}
          headerImage={data && data.headerImage}
        />

        <HowItWorksSection/>

        <ReviewsSection/>

        <AdvantagesSection/>

        <StaticContentSection
          ctaTitle={getKey(data, 'ctaTitle')}
          content={getKey(data, 'content')}
          staticPages={staticPages || []}
          onCtaClick={this.onSearchHandler}
        />

        {!!cityBikes && !!cityBikes.length && !!city && (
          <CityBikesSection
            bikes={cityBikes}
            bikeType={data && data.bikeType}
            bikeTypes={bikeTypes}
            city={city}
            currency={currency}
            onSelect={this.onSelectHandler}
          />
        )}

        {!!data && !!data.related && (
          <RelatedCitiesSection
            related={data.related}
          />
        )}
      </div>
    );
  }
}

StaticCityPage.propTypes = {
  isFetching: PropTypes.bool,
  data: PropTypes.object,
  error: PropTypes.object,
  city: PropTypes.object,
  cityBikes: PropTypes.array,
  country: PropTypes.object,
  countries: PropTypes.array,
  bikeTypes: PropTypes.array,
  staticPages: PropTypes.array,
  clearCityBikes: PropTypes.func,
  clearStaticPage: PropTypes.func
};

StaticCityPage.defaultProps = {
  isFetching: false,
  data: null,
  error: null,
  city: null,
  cityBikes: [],
  country: null,
  countries: [],
  bikeTypes: [],
  staticPages: []
};

export default StaticCityPage;



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/StaticCityPage.js